module.exports = __webpack_public_path__ + "static/img/theme_02.ff6adeec.png";